export default __webpack_public_path__ + "static/media/exchange.24bcf404.png";